function isString(value) {
  return typeof value === "string";
}

function isNumber(value) {
  return typeof value === "number";
}

function isArray(value) {
  return Array.isArray(value);
}

function isStringArray(value) {
  return isArray(value) && value.every(isString);
}

function isNumberArray(value) {
  return isArray(value) && value.every(isNumber);
}

function isObject(value) {
  return typeof value === "object" && value !== null;
}

function isFunction(value) {
  return typeof value === "function";
}

export {
  isArray,
  isNumber,
  isNumberArray,
  isObject,
  isString,
  isStringArray,
  isFunction,
};
